<template>
    <admin-layout>
        <div class="content" slot="main">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <div class="inner">
                    <h3>User Settings for {{userModel.email }}</h3>
                    <FormulateForm #default="{ hasErrors }" @submit="save">
                        <FormulateInput type="text" v-model="userModel.first_name" label="First Name" validation="required" />
                        
                        <FormulateInput type="text" v-model="userModel.last_name" label="Last Name" validation="required" />
                        <FormulateInput type="submit" :disabled="hasErrors"  label="Save"/>
                    </FormulateForm>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="inner">
                    <h3>Change Password</h3>
                    <FormulateForm #default="{ hasErrors }" @submit="updatePassword">    
                        <FormulateInput type="password" v-model="passwordModel.old_password" label="Current Password"
                                        validation="required|isValidOldPassword"
                                        :validation-rules="{ isValidOldPassword: isValidOldPassword }"
                                        error-bahavior="live"
                        />
                        <FormulateInput type="password" v-model="passwordModel.new_password1" label="New Password" validation="required" @input="validPassword = []"/>
                        <FormulateInput type="password" v-model="passwordModel.new_password2"
                                        error-behavior="live"
                                        label="Repeat New Password"
                                        @input="validPassword = []"
                                        validation="required|samePassword|isValidPassword"
                                        :validation-rules="{
                                            samePassword: samePassword,
                                            isValidPassword: isValidPassword
                                        }"
                                        :validation-messages="{
                                            samePassword: 'Please enter the same password',
                                            isValidPassword: validPasswordMsg}" />
                        
                        <FormulateInput type="submit" :disabled="hasErrors"  label="Change Password"/>
                    </FormulateForm>
                    </div>
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
 import Vue from 'vue'; 
 import {AdminLayout} from 'components/layouts/';
 // Load the full build
 var _ = require('lodash');
 
 export default {
     components: {
         AdminLayout
     },
     
     data () {
         return {
             emailExists: false,
             validPassword: [],
             validOldPassword: [],
             userModel: {
                 id: null,
                 email: null,
                 first_name: null,
                 last_name: null
             },
             passwordModel: {
                 old_password: null,
                 new_password1: null,
                 new_password2: null
             }
         }
     },
     
     created () {
         let userProxy = this.$store.state.user;
         this.userModel.id = userProxy.id;
         this.userModel.email = userProxy.email;
         this.userModel.first_name = userProxy.first_name;
         this.userModel.last_name = userProxy.last_name;
     },
     computed: {
         validPasswordMsg: function () {
             if (this.validPassword) {
                 return this.validPassword.join(' '); 
             }
             else {
                 return 'Password not updated!';
             }
         }
     },
     methods: {
         isUnique: function () {
             return !this.emailExists;
         },
         isValidPassword: function () {
             return !!this.validPassword;
         },
         isValidOldPassword: function () {
             
             return !!this.validOldPassword;
         },
         samePassword: function() {
             return this.passwordModel.new_password1 == this.passwordModel.new_password2;
         },
         updatePassword: _.debounce(function () {
             let self = this;
             API.user.changePassword(self.passwordModel)
                .then(
                    (res) => {
                        this.passwordModel.old_password = null;
                        this.passwordModel.new_password1 = null;
                        this.passwordModel.new_password2 = null;
                        Vue.toast('Password updated successfully!', {
                            className: ['et-info'],
                        });
                    },
                    (err) => {
                        var msg = 'Password not updated!';
                        if ('new_password2' in err.data) {
                            self.validPassword = err.data.new_password2;
                            msg = self.validPasswordMsg;
                        }
                        else if ('old_password' in err.data) {
                            self.validOldPassword = err.data.old_password;
                            msg = err.data.old_password[0];
                            self.passwordModel.old_password = self.passwordModel.old_password;
                        }
                        
                        Vue.toast(msg, {
                            className: ['et-error'],
                        });
                })
             
         }),
         save: _.debounce(function () {
             var requestData = {
                 first_name: this.userModel.first_name,
                 last_name: this.userModel.last_name
             };
             
             var self = this;
             
             API.user.update(requestData)
                .then(
                    (response) => {
                        self.userModel.first_name = response.data.first_name;
                        self.userModel.last_name = response.data.last_name;
                        self.userModel.email = response.data.email;          
                        
                        Vue.toast('Changes saved successfully!', {
                            className: ['et-info'],
                        });
                    },
                    (err) => {
                        self.emailExists = true;
                        Vue.toast( 'The email is already in use', {
                            className: ['et-error'],
                        });
                });
             
         }, 500),
     }    
 }
</script>
<style scoped>

 .inner {
     padding-left: 2rem;
     padding-right: 2rem;
}
 
 
</style>




// WEBPACK FOOTER //
// ProfileSettings.vue?494c190f